import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/dollar-coin.png")